export class ServiceRequest {
    createdDate = new Date();
    dbmDate = null;
}
